import { IOrdemCargaPage } from '../../../../../store/ducks/ordemCargaPage/types';

interface ExportBtnProps {
  'Tipo WMS ': string;
  'Ordem de carga': string;
  'Status ': string;
  'Transportadora ': string;
  'Placa ': string;
  'Veículo ': string;
  'Motorista ': string;
  'CPF ': string;
  'Peso ': string;
  'Valor ': string;
}

export const exportDataOrdemCarga = (data: IOrdemCargaPage[]): ExportBtnProps[] =>
  data?.map((item) => {
    return {
      'Tipo WMS ': item.tipoWms === 'EXP' ? 'Coleta' : 'Entrega',
      'Ordem de carga': item.ordemCarga?.toString(),
      'Status ': item.status?.toString(),
      'Transportadora ': item.transportadora?.toString(),
      'Placa ': item.placa?.toString(),
      'Veículo ': item.tipVei?.toString(),
      'Motorista ': item.motorista?.toString(),
      'CPF ': item.cpfMotorista?.toString(),
      'Peso ': item.pesoTotal?.toString(),
      'Valor ': item.vlrTotal?.toString(),
    };
  });
